import { useRef, useState } from "react";
import { Card, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import Schedule from "./Schedule";
import moment from "moment";

export default function Opd() {
  const [show, setShow] = useState(false);

  const conDoctorRef = useRef(null);
  const apntDateRef = useRef(null);
  const apntStartTimeRef = useRef(null);
  const apntEndTimeRef = useRef(null);
  const handleClose = () => setShow(false);
  const eventClick = (info) => {
    console.log(info.event);
    // setConDoctor(info.event.title);
    conDoctorRef.current.value = info.event.title;
    apntDateRef.current.value = moment(info.event.start).format("YYYY-MM-DD");
    apntStartTimeRef.current.value = moment(info.event.start).format("HH:mm");
    apntEndTimeRef.current.value = moment(info.event.end).format("HH:mm");
    // setApntDate(moment(info.event.start).format('YYYY-MM-DD'));
    // console.log(moment());
  };
  return (
    <>
      <Schedule show={show} handleClose={handleClose} eventClick={eventClick} />
      <fieldset>
        <legend>Doctor's Information</legend>
        <Card className="mb-3">
          <Card.Body>
            <Row xs={1}>
              <Col>
                <Form.Group>
                  <Form.Label>Consultant Doctor</Form.Label>
                  <InputGroup className="mb-3">
                    <Form.Control ref={conDoctorRef} />
                    <Button
                      variant="outline-secondary"
                      onClick={() => setShow(true)}
                    >
                      Check Availability
                    </Button>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Row xs={2}>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Appointment Date</Form.Label>
                  <Form.Control type="date" ref={apntDateRef} />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Appointment Start Time</Form.Label>
                  <Form.Control type="time" ref={apntStartTimeRef} />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Appointment End Time</Form.Label>
                  <Form.Control type="time" ref={apntEndTimeRef} />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Fee</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </fieldset>

      <fieldset>
        <legend>Appointment Purpose</legend>
        <Card className="mb-3">
          <Card.Body>
            <Form.Group className="mb-3">
              <Form.Label>Symptoms</Form.Label>
              <Form.Control as="textarea"></Form.Control>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Have consulted any other doctor? &nbsp;</Form.Label>
              <Form.Check
                inline
                label="Yes"
                type="radio"
                id="other-doctor-yes"
              />
              <Form.Check inline label="No" type="radio" id="other-doctor-no" />
            </Form.Group>
            <Row xs={2}>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Reffered From</Form.Label>
                  <Form.Control></Form.Control>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Prescription Image</Form.Label>
                  <Form.Control type="file"></Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group>
              <Form.Label>Any Chronic Problem?</Form.Label>
              <Form.Control as="textarea" />
            </Form.Group>
          </Card.Body>
        </Card>
      </fieldset>

      <fieldset>
        <legend>Payment Detail</legend>
        <Card className="mb-3">
          <Card.Body>
            <Row xs={2}>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Payment Mode</Form.Label>
                  <Form.Select></Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Amount Paid</Form.Label>
                  <Form.Control></Form.Control>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Refference Number</Form.Label>
                  <Form.Control></Form.Control>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </fieldset>
    </>
  );
}
